export type contactSubject =
  'Dúvidas sobre o site'
  | 'Redação Nota 1000 nas escolas'
  | 'Como ser professor do Redação Nota 1000'
  | 'Outros';


export const contactSubjectOptions: contactSubject[] = [
  'Dúvidas sobre o site',
  'Redação Nota 1000 nas escolas',
  'Como ser professor do Redação Nota 1000',
  'Outros'
];
